<template>
  <el-container class="container">
    <el-header class="header" height="60px">
      <div class="logo-content">
        <!-- 菜单组仅为1组不显示 -->
        <p
          class="menu"
          @click="handleMenuGroupDrawerOpen"
          v-if="menuListLength > 1"
        >
          <i class="el-icon-s-unfold"></i>
          菜单
        </p>
        <img v-if="ico.length > 0" :src="'data:image/png;base64,' + ico" />
        <img v-else src="../../assets/images/logo_yw.png" />
      </div>

      <div
        class="header-top"
        style="overflow: hidden; position: relative; display: flex"
      >
        <template v-if="mode == 'horizontal'">
          <div
            v-show="isShowArrow"
            class="menu-left-btn"
            @click="bindMenuPosition(false)"
          >
            <i class="el-icon-arrow-left"></i>
          </div>
          <div
            id="horizontalMenuWarp"
            style="
              overflow: hidden;
              position: relative;
              width: calc(100% - 40px);
              height: 100%;
              margin: 0px auto;
            "
          >
            <div
              style="position: absolute; top: 3px; left: 0px; width: 100%"
              id="horizontalMenu"
            >
              <sidebar-transverse
                id="horizontalSidebar"
                ref="horizontalSidebar"
                :menuList="menuList"
                :collapse="collapse"
              ></sidebar-transverse>
            </div>
          </div>
          <div
            v-show="isShowArrow"
            class="menu-right-btn"
            @click="bindMenuPosition(true)"
          >
            <i class="el-icon-arrow-right"></i>
          </div>
        </template>
      </div>
      <div class="header-user">
        当前绑定公司：
        <div v-if="company" class="com-btn">
          <span :title="company.name">
            {{ company.name }}
          </span>
          <span class="com-btn-change" @click="showChangeCompanyDialog"
            >切换</span
          >
        </div>
        <div class="header-item" @click="bindGotoMsg">
          <i class="iconfont icon-gaojing icon-font-22"></i>
          消息中心{{ notifyMsgTotal == 0 ? "" : "(" + notifyMsgTotal + ")" }}
        </div>
        <el-dropdown
          class="dropdown-st"
          trigger="click"
          @command="handleCommand"
        >
          <div class="header-item">
            <i class="iconfont icon-denglu icon-font-22"></i>
            欢迎您！{{ this.$store.state.user.info.nickname }}
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="user">个人信息</el-dropdown-item>
            <el-dropdown-item command="signOut">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="header-item" @click="bindScreen">
          <i class="el-icon-rank icon-font-22"></i>
        </div>
      </div>
    </el-header>
    <el-container class="layou-container">
      <el-aside
        :width="collapse ? '64px' : '200px'"
        v-if="mode == 'vertical'"
        class="aside"
      >
        <div
          class="collapse"
          @click="collapseSidebar"
          :style="{
            background: isIE()
              ? 'rgba(188, 188, 188, 0.49)'
              : 'rgba(188, 188, 188, 0.38)',
          }"
        >
          <span v-if="isIE()" class="collapse_before"></span>
          <i
            :class="{
              'el-icon-caret-left': !collapse,
              'el-icon-caret-right': collapse,
            }"
          ></i>
          <span v-if="isIE()" class="collapse_after"></span>
        </div>
        <div
          class="bigScreen"
          v-show="bigScreenUrl.length > 0"
          @click="bindGotoBig"
        >
          <i class="el-icon-s-platform"></i>
          <label>可视化平台</label>
        </div>
        <Sidebar :menuList="menuList" :collapse="collapse" />
      </el-aside>
      <el-container>
        <el-main class="main">
          <div class="tab-view">
            <tab-view></tab-view>
            <!-- 天气 -->
            <div class="weather-box">
              <div class="weather-content" v-if="weather !== null">
                <label>{{ weather.text }}</label>
                <label>{{ weather.temperature }}°C</label>
              </div>
            </div>
            <p class="time">{{ date }} {{ week }} {{ time }}</p>
          </div>
          <div class="router-view" id="contentBox">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
            <div v-show="showIfame" style="width: 100%; height: 100%">
              <div
                style="width: 100%; height: 100%"
                v-for="(item, index) in srcList"
                :key="index"
                v-show="item === active"
              >
                <iframe
                  class="content iframe-content"
                  style="width: 100%; height: 100%"
                  :src="item"
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </el-main>
        <el-footer :height="'30px'" class="layout-footer footer">
          <div
            style="
              font-size: 20px;
              font-weight: bold;
              position: absolute;
              left: 2px;
              cursor: pointer;
              z-index: 10;
            "
            @click="bindBlare"
            :title="blare ? '点击关闭告警警报声音' : '点击打开告警警报声音'"
          >
            <i class="el-icon-close-notification" v-if="!blare"></i>
            <i class="el-icon-bell" v-else></i>
          </div>
          <div class="footer-msg" style="background: #fdfbde">
            <ul class="marquee_list" :class="{ marquee_top: animate }">
              <li
                v-for="(item, index) in handlingData"
                :key="index"
                @click="bindGotoAlarm(item)"
              >
                <span
                  >【{{ item.eventTime }}】{{ item.measureName }}:{{
                    item.content
                  }}</span
                >
              </li>
            </ul>
          </div>
          Copyright © All Rights Reserved.备案号：<a
            class="internet-content-provider"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            >粤ICP备19085808号</a
          >
        </el-footer>
      </el-container>
    </el-container>
    <div class="pop" v-if="vDialogVisible">
      <div class="content">
        <div class="content-title">当前版本号：{{ version.version }}</div>
        <div class="content-title">更新时间：{{ version.date }}</div>
        <div class="content-title">更新日志：</div>
        <div class="content-remark" v-html="version.remark"></div>
        <div class="foot">
          <div class="foot-left">
            <label @click="bindGoToVersion">升级日志</label>
          </div>
          <el-button type="primary" @click="vDialogVisible = false"
            >确认</el-button
          >
        </div>
      </div>
    </div>
    <div class="pop" v-if="showEventMsg">
      <div class="pop-content">
        <div class="title">
          <div class="title-lab">告警通知</div>
          <!-- <i class="icon-close el-icon-close"></i> -->
          <el-button
            type="text"
            @click="bindConfimEvent(-1)"
            icon="el-icon-success"
            style="color: #ffffff"
            >全部确认</el-button
          >
        </div>
        <div class="list">
          <div class="item" v-for="(item, index) in eventData" :key="index">
            <div class="item-title">
              <div style="flex: 1; text-align: left">
                告警源：
                <label style="color: #ff0707">{{ item.measureName }}</label>
              </div>
              <div style="flex: 1; text-align: left">
                告警总数：
                <label style="color: #ff0707">{{ item.data.length }}</label>
              </div>
              <el-button
                type="text"
                @click="bindConfimEvent(index)"
                icon="el-icon-success"
                >确认告警</el-button
              >
              <!-- <el-button type="text" @click="bindGotoAlarm(item)">点击查看详情</el-button> -->
            </div>
            <div>
              <table
                style="width: 100%; text-align: left; margin-left: -3px"
                border="0"
              >
                <tr>
                  <td style="width: 150px">告警时间</td>
                  <td style="width: 100px">告警等级</td>
                  <td style="width: 100px">告警类型</td>
                  <td>告警内容</td>
                </tr>
                <tr v-for="(obj, index2) in item.data" :key="index2">
                  <td>{{ obj.eventTime }}</td>
                  <td :style="{ color: obj.levelColor }">
                    {{ obj.levelName == "" ? "-" : obj.level }}
                  </td>
                  <td>{{ obj.displayName }}</td>
                  <td>{{ obj.content }}</td>
                  <td>
                    <el-link type="primary" @click="openAlarmDetailsModel(obj)"
                      >告警详情</el-link
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <theme ref="theme"></theme>
    <el-dialog title="告警详情" :visible.sync="showDetails" width="800px">
      <nk-chart
        v-if="showDetails"
        :data="chartData"
        :timeTitle="timeTitle"
        title="波形分析"
        :unit="unit"
        :showTitle="false"
        :markLine="markLine"
        class="dialog"
      ></nk-chart>
    </el-dialog>
    <select-company :visible.sync="selectCompanyDialogVisible"></select-company>
    <!-- 菜单组抽屉 -->
    <menu-group-drawer
      ref="menuGroupDrawer"
      v-if="menuGroupDrawerVisible"
    ></menu-group-drawer>
    <!-- 告警声音插件 -->
    <audio src="" id="NkAudio"></audio>
  </el-container>
</template>
<script>
import Sidebar from "./Sidebar.vue";
import Cookie from "@/utils/cookie"; // 验权
import TabView from "./TabView.vue";
import Theme from "./Theme.vue";
import DateTool from "@/utils/dateTool.js";
import api from "../../../../common/api/index";
import tree from "@/utils/tree";
import socket from "@/utils/websocket.js"; // 组件
import dateTool from "@/utils/dateTool.js";
import cookie from "@/utils/cookie";
import { TOKEN_KEY } from "@/config/index";
import SidebarTransverse from "./sideBarTransverse/SidebarTransverse.vue";
import handleData from "@/utils/handleData.js";
import NkChart from "@/components/common/NkChart.vue";
import MenuGroupDrawer from "./MenuGroupDrawer";
import { mapState } from "vuex";
import { weather, weatherUpdateInterval } from "../../utils/weather";
import SelectCompany from "./selectCompany.vue";

export default {
  components: {
    Sidebar,
    TabView,
    Theme,
    SidebarTransverse,
    NkChart,
    MenuGroupDrawer,
    SelectCompany,
  },
  data() {
    return {
      project: window.baseConfig.project,
      companyName: window.baseConfig.companyName,
      time: "",
      week: "",
      date: "",
      select: "1",
      menuList: this.$store.state.user.menuData,
      collapse: false,
      menuGroupDrawerVisible: false,
      vDialogVisible: false,
      version: null,
      visible: false,
      company: null,
      webSock: {
        ip: "",
        port: "",
        key: "",
        path: "",
      },
      showIfame: false,
      srcList: [],
      active: "",
      eventData: [],
      showEventMsg: false,
      animate: false,
      handlingData: [],
      timerLock: false,
      mode: "",
      styleIndex: 0,
      token: cookie.getToken(),
      blare: true,
      bigScreenUrl: window.baseConfig.bigScreenUrl,
      ico: "",
      isShowArrow: false,
      eventLevel: [],
      unit: "", //单位
      markLine: null,
      showDetails: false, //告警详细信息弹窗状态
      timeTitle: "", //告警详细信息时间范围
      chartData: [], //echarts对象
      menuGroupLength: 0,
      menuListLength: 0,
      weather: "",
      selectCompanyDialogVisible: false,
    };
  },
  created() {
    this.handleShowMenuGroup();
    let companyId = null;
    if (Cookie.getCookie(TOKEN_KEY + "_companyId")) {
      companyId = Cookie.getCookie(TOKEN_KEY + "_companyId");
    }
    this.$store.state.user.companyId = companyId;
    //设置默认主题
    let theme = cookie.getCookie("theme");
    const themeList = ["theme-dark", "theme-light", "theme-defalt"];
    if (!theme || typeof theme == "undefined" || !themeList.includes(theme)) {
      theme = "theme-defalt";
      cookie.setCookie("theme", theme);
    }
    let mode = cookie.getCookie("mode");
    if (!mode || typeof mode == "undefined" || mode == "") {
      mode = "vertical";
      cookie.setCookie("mode", mode);
    }
    this.mode = mode;
    document.querySelector("body").setAttribute("class", theme);
    this.$store.commit("data/SET_THEME_DATA", theme);

    //是否打开告警声音
    let blare = cookie.getCookie("blare");
    if (blare == "1") {
      this.blare = true;
    } else if (blare == "0") {
      this.blare = false;
    } else {
      this.blare = true;
      cookie.setCookie("blare", 1);
    }

    this.setIfame(this.$route);

    this.getEvent();

    this.getKey();
    this.getLangDate();
    this.getNotifyMsg();
    this.getSubcompaniesInfo();
    this.getLogo();

    // 获取天气情况
    const getWeather = () => {
      weather.getWeather().then((res) => {
        if (res) {
          this.weather = res["results"][0].now;
          setTimeout(() => {
            getWeather();
          }, weatherUpdateInterval);
        }
      });
    };
    getWeather();
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    let vm = this;
    window.addEventListener(
      "message",
      function(event) {
        //跳转页面
        if (event.data.type == "GO_TO_PAGE") {
          vm.$router.push({ path: event.data.page, query: event.data.query });
        }
      },
      false
    );
    vm.$eventBus.$on("changeMode", (mode) => {
      vm.mode = mode;
    });
    window.onresize = () => {
      this.setTopMenuLleftRight_dot();
    };
    window.addEventListener("keydown", this.KeyDown, true); // 监听按键事件
    this.moveDiv();
  },
  // 清除计时器
  beforeDestroy() {
    this.stopVoice();
  },
  watch: {
    $route(to, from) {
      this.setIfame(to);
      this.moveDiv();
    },
  },
  computed: {
    ...mapState({ menuGroup: (state) => state.user.menuGroup }),
    notifyMsgTotal() {
      return this.$store.state.data.notifyMsgTotal;
    },
  },
  methods: {
    showChangeCompanyDialog() {
      this.selectCompanyDialogVisible = true;
    },
    //去除多余div
    moveDiv() {
      this.$nextTick(() => {
        let dom = document.getElementById("contentBox").children;
        if (this.$route.path == "/systemMicrofront") {
          if (this.showIfame) {
            if (dom.length > 1 && dom[0].children[0]) {
              if (
                dom[0].getElementsByTagName("iframe").length == 0 &&
                dom.length > 1 &&
                dom[0].children[0].clientHeight == 0
              ) {
                dom[0].classList.add("height0");
              }
            }
          }
        } else {
          dom[0].classList.remove("height0");
        }
      });
    },
    /*判断是否是IE*/
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return true;
      } else {
        return false;
      }
    },
    /* 打开告警详情弹窗事件 */
    async openAlarmDetailsModel(row) {
      if (!row.regulationParam) {
        this.$message.warning("当前告警没有告警详情");
        return;
      }
      let regulationParam = JSON.parse(row.regulationParam);
      let eventTime = new Date(row.eventTime);
      let date = new Date();
      let pointCode = regulationParam.pointCode;
      let pointNumber = regulationParam.pointNumber;
      date.setMinutes(date.getMinutes() - 30);
      let startTime, endTime;
      if (eventTime < date) {
        startTime = new Date(row.eventTime);
        endTime = new Date(row.eventTime);
        startTime.setMinutes(startTime.getMinutes() - 30);
        endTime.setMinutes(endTime.getMinutes() + 30);
      } else {
        startTime = new Date(row.eventTime);
        endTime = new Date();
        startTime.setMinutes(startTime.getMinutes() - 30);
      }
      let strStartTime = DateTool.format(startTime, "yyyy-MM-dd hh:mm:ss");
      let strEndTime = DateTool.format(endTime, "yyyy-MM-dd hh:mm:ss");
      let valueAllElem = [
        {
          measureId: row.measureId,
          pointCode: pointCode,
          pointNumber: pointNumber,
        },
      ];
      let res = await api.measuring.getMeasuringValueAll2(
        valueAllElem,
        strStartTime,
        strEndTime,
        0,
        0
      );

      if (!res) {
        return;
      }

      let selectNodes = [{ id: row.measureId, label: row.measureName }];
      let itemCollect = window.baseConfig.collectData.find(
        (obj) => obj.code == pointCode
      );
      if (!itemCollect) {
        return;
      }
      let codes = [
        {
          code: itemCollect.code,
          title: itemCollect.name,
          show: true,
        },
      ];

      let chartData = handleData.matchMeasuringData(
        res.data,
        selectNodes,
        codes
      );
      let markLineData = [];
      if (regulationParam.threshold) {
        markLineData.push({
          yAxis: regulationParam.threshold,
          name: "告警值",
          lineStyle: {
            color: "red",
          },
        });
      }
      if (regulationParam.recover) {
        markLineData.push({
          yAxis: regulationParam.recover,
          name: "恢复值",
          lineStyle: {
            color: "green",
          },
        });
      }
      this.markLine = {
        data: markLineData,
      };
      this.timeTitle = strStartTime + "~" + strEndTime;
      this.chartData = chartData;
      this.showDetails = true;
    },
    setTopMenuLleftRight_dot() {
      const isHavDom =
        document.getElementById("horizontalSidebar") != null &&
        document.getElementById("horizontalSidebar") != undefined;
      if (isHavDom) {
        let menuUL_d = document.getElementById("horizontalMenu").offsetWidth;
        let horizontalMenuWidth = document.getElementById("horizontalMenuWarp")
          .offsetWidth;
        menuUL_d > horizontalMenuWidth
          ? (this.isShowArrow = true)
          : (this.isShowArrow = false);
      }
    },
    getLogo() {
      let vm = this;
      vm.$api.company
        .getCompanyLogo(vm.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res) {
            vm.ico = res.data ? res.data : "";
          }
        });
    },
    bindBlare() {
      let vm = this;
      //关闭
      if (vm.blare) {
        vm.blare = false;
        this.$message("成功关闭警报！");
        cookie.setCookie("blare", 0);
      } else {
        vm.blare = true;
        this.$message("成功打开警报!");
        cookie.setCookie("blare", 1);
      }
    },
    bindMenuPosition(isRight) {
      let vm = this;
      let offsetWidth = vm.$refs.horizontalSidebar.$el.offsetWidth;
      let offsetLeft = document.getElementById("horizontalMenu").offsetLeft;
      let horizontalMenuWidth = document.getElementById("horizontalMenuWarp")
        .offsetWidth;

      let value = 0;
      let index = 0;
      let end = 0;
      if (isRight) {
        if (Math.abs(offsetLeft) + horizontalMenuWidth >= offsetWidth) {
          return;
        }
        //160*3
        if (Math.abs(offsetLeft) + horizontalMenuWidth + 540 >= offsetWidth) {
          vm.styleIndex = 10;
          vm.animation(
            (offsetWidth - horizontalMenuWidth) / -10,
            -(offsetWidth - horizontalMenuWidth)
          );
        } else {
          vm.styleIndex = 10;
          vm.animation(-540 / 10, offsetLeft - 540);
        }
      } else {
        if (offsetLeft == 0) {
          return;
        }
        if (Math.abs(offsetLeft) - 540 >= 0) {
          vm.styleIndex = 10;
          vm.animation(540 / 10, offsetLeft + 540);
        } else {
          vm.styleIndex = 10;
          vm.animation(offsetLeft / 10, 0);
        }
      }
    },

    animation(value, end) {
      let vm = this;
      requestAnimationFrame(function() {
        if (vm.styleIndex > 0) {
          document.getElementById("horizontalMenu").style.left =
            document.getElementById("horizontalMenu").offsetLeft + value + "px";
          vm.styleIndex--;
          vm.animation(value, end);
        } else {
          document.getElementById("horizontalMenu").style.left = end + "px";
          return;
        }
      });
    },
    setIfame(to) {
      if (to.path == "/Microfront") {
        this.showIfame = true;
        const url = window.baseConfig.configurationUrl + to.query.url;

        const item = this.srcList.find((obj) => obj === url);
        if (item) {
          this.active = url;
        } else {
          this.srcList.push(url);
          this.active = url;
        }
      } else if (to.path == "/systemMicrofront") {
        this.showIfame = true;

        let sysUrl = window.baseConfig.systemUrl + to.query.url;
        const item = this.srcList.find((obj) => obj === sysUrl);

        if (item) {
          this.active = sysUrl;
        } else {
          this.srcList.push(sysUrl);
          this.active = sysUrl;
        }
      } else {
        this.showIfame = false;
      }
    },
    bindGoToVersion() {
      this.vDialogVisible = false;
      this.$router.push("/Version");
    },
    handleCommand(val) {
      let vm = this;
      switch (val) {
        case "user":
          vm.$router.push("/system/personalCenter");
          break;
        case "about":
          vm.$router.push("/about");
          break;
        case "theme":
          vm.$refs.theme.bindShowTheme();
          break;
        case "backTo":
          vm.backTo();
          break;
        case "signOut":
          vm.bindSignOut();
          break;
      }
    },
    getEvent() {
      let vm = this;
      let codes = [];
      let startDate = new Date().setDate(new Date().getDate() - 1);
      let endDate = new Date();
      api.event
        .getEventNotifyLevelRedefines(this.$store.state.user.currentCompanyId)
        .then((resObj) => {
          this.eventLevel = resObj.data;
          api.event
            .getEventRecord(
              this.$store.state.user.currentCompanyId,
              codes,
              codes,
              codes,
              null,
              null,
              codes,
              dateTool.format(new Date(startDate), "yyyy-MM-dd hh:mm:ss"),
              dateTool.format(new Date(endDate), "yyyy-MM-dd hh:mm:ss"),
              0,
              0
            )
            .then((res) => {
              let resData = res.data.sort((a, b) => {
                return (
                  new Date(b.eventTime).getTime() -
                  new Date(a.eventTime).getTime()
                );
              });
              //合并告警源
              let data = [];
              let handlingData = [];
              for (let i = 0; i < resData.length; i++) {
                let element = resData[i];
                if (element.handlingUserId == -1) {
                  continue;
                }
                if (
                  resData[i].confirmingUserId == 0 &&
                  resData[i].handlingUserId == 0
                ) {
                  const itemIndex = data.findIndex(
                    (c) => c.measureId == element.measureId
                  );
                  if (itemIndex > -1) {
                    data[itemIndex].data.push(element);
                  } else {
                    element.data = [element];
                    data.push(element);
                  }
                } else {
                  handlingData.push(element);
                }
              }
              vm.eventData = data;
              vm.handlingData = handlingData;

              vm.showEventMsg = false;
              if (data.length > 0 && vm.showEventMsg == false) {
                vm.showEventMsg = true;
                this.$nextTick(() => {
                  this.voiceSound();
                });
                // 弹窗弹出，告警声音开启
                //是否打开告警声音
              }
              if (handlingData.length > 0) {
                setInterval(vm.showMarquee, 2000);
              }
            });
        });
    },
    //警报  state  on:打开   off  关闭
    executeCommandOnMeasure(state) {
      let vm = this;
      let measureId = window.baseConfig.eventMeasureId;
      if (!measureId || measureId.length == 0) {
        return;
      }
    },
    showMarquee: function() {
      if (this.timerLock) {
        return;
      } else {
        this.timerLock = true;
        this.animate = true;
        setTimeout(() => {
          this.handlingData.push(this.handlingData[0]);
          this.handlingData.shift();
          this.animate = false;
          this.timerLock = false;
        }, 1000);
      }
    },
    getLangDate() {
      const dateObj = new Date(); //表示当前系统时间的Date对象
      this.time = DateTool.format(dateObj, "hh:mm");
      this.date = DateTool.format(dateObj, "MM月dd日");
      const weeks = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const week = weeks[dateObj.getDay()]; //根据星期值，从数组中获取对应的星期字符串
      this.week = week;
      setTimeout(this.getLangDate, 1000);
    },
    collapseSidebar() {
      this.collapse = !this.collapse;
    },
    //返回统一登录平台
    backTo() {
      this.$confirm("确定返回统一登录平台？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          window.location = window.baseConfig.platformUrl;
        })
        .catch(() => {});
    },
    bindSignOut() {
      this.$confirm("退出当前账号？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit("tabView/SET_DEFAT_OPENTABS");
          this.$store.dispatch("user/fedLogOut").then((res) => {
            window.location.replace(
              `${window.baseConfig.loginServeUrl}/Signout?&redirectUrl=${window.location.href}`
            );
          });
        })
        .catch(() => {});
    },
    full(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    KeyDown(event) {
      if (event.keyCode === 122) {
        this.bindScreen();
        event.preventDefault();
      }
    },
    bindScreen() {
      let fullarea = document.getElementById("contentBox");
      fullarea.style.background = "#fff"; //全屏内容背景白色
      if (fullarea.requestFullscreen) {
        fullarea.requestFullscreen();
      } else if (fullarea.webkitRequestFullScreen) {
        fullarea.webkitRequestFullScreen();
      } else if (fullarea.mozRequestFullScreen) {
        fullarea.mozRequestFullScreen();
      } else if (fullarea.msRequestFullscreen) {
        // IE11
        fullarea.msRequestFullscreen();
      }

      this.$store.commit("data/SET_SHOW_TOP");
    },
    bindGotoMsg() {
      this.$router.push({
        path: "/system/msg/msg",
      });
    },
    bindGotoAlarm(item) {
      this.showEventMsg = false;
      // 确认告警后关闭告警声音
      this.stopVoice();
      this.$eventBus.$emit("alarmGetEvent", item.measureId);
      this.$router.push({
        path: "/alarm/alarm",
        query: { measureId: item.measureId },
      });
    },
    bindConfimEvent(index) {
      let vm = this;
      let ids = [];
      let title = "";
      if (index == -1) {
        title = "所有";
        for (let i = 0; i < vm.eventData.length; i++) {
          const element = vm.eventData[i];
          for (let j = 0; j < element.data.length; j++) {
            ids.push(element.data[j].id);
          }
        }
      } else {
        title = "该";
        for (let j = 0; j < vm.eventData[index].data.length; j++) {
          ids.push(vm.eventData[index].data[j].id);
        }
      }
      this.$confirm("是否确认" + title + "告警?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //进行告警确认请求
          api.event.confirmEvent(JSON.stringify(ids)).then((res) => {
            if (res.success) {
              if (index == -1) {
                vm.eventData = [];
                vm.showEventMsg = false;
                // 确认告警后关闭告警声音
                this.stopVoice();
              } else {
                if (vm.eventData.length == 1) {
                  vm.showEventMsg = false;
                  // 确认告警后关闭告警声音
                  this.stopVoice();
                  vm.eventData = [];
                  vm.getEvent();
                } else {
                  vm.eventData.splice(index, 1);
                }
              }
            }
          });
        })
        .catch(() => {});
    },
    async getSubcompaniesInfo() {
      let vm = this;
      await api.company
        .getCompanyInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          vm.company = res.data;
        });
      let com = null;
      await api.company
        .getCompanyInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          com = res.data;
        });
      await api.company
        .getSubcompaniesInfo(this.$store.state.user.currentCompanyId, 1)
        .then((res) => {
          let data = tree.creatTreeJson(
            res.data,
            this.$store.state.user.currentCompanyId
          );
          let companyData = [
            {
              id: vm.$store.state.user.currentCompanyId,
              name: com.name,
              parentId: 0,
              children: data,
            },
          ];
          vm.companyData = companyData;
        });
      this.setTopMenuLleftRight_dot();
    },

    async getKey() {
      const {
        data,
        success,
      } = await api.messageServer.allotMessageRealtimeNotifyServer();
      if (success && data) {
        this.webSock.ip = data.ip;
        this.webSock.port = data.port;
        this.webSock.key = data.key;
        this.webSock.path = data.path;

        let agentData = {
          methodCode: "201",
          key: this.webSock.key,
        };

        this.socket = new socket({
          //网址（端口是我下面的服务器的端口）
          url:
            window.baseConfig.wsAgreement +
            "://" +
            data.ip +
            ":" +
            data.port +
            "/" +
            data.path,
        });

        this.socket.onopen((event) => {
          this.socket.send(agentData);
        });
        //接收信息
        this.socket.onmessage((data) => {
          this.webSockMsg(JSON.parse(data));
        });
      }
    },
    webSockMsg(e) {
      let vm = this;
      if (e.methodCode == "203") {
        let type = "success";
        if (e.data.action == "1" || e.data.action == "2") {
          type = "info";
        }

        vm.getNotifyMsg();
        if (e.data.type == "2" || e.data.type == "3") {
          vm.getEvent();
        }
      }
    },
    getNotifyMsg() {
      let startDate = new Date().setDate(new Date().getDate() - 30);
      let endDate = new Date();
      api.notifyMsg.getUnReadNotifyMsgCount().then((res) => {
        this.$store.commit("data/SET_NOTIFY_MSG_TOTAL", res.data || 0);
      });
    },
    handleMenuGroupDrawerOpen() {
      this.menuGroupDrawerVisible = true;
    },
    bindGotoBig() {
      window.open(this.bigScreenUrl + "&token=" + Cookie.getToken());
    },
    handleShowMenuGroup() {
      this.menuGroupLength = this.menuGroup.length;
      let menuList = [];
      this.menuGroup.forEach((item) => {
        console.log(item);
        if (item.list !== null && item.list.length > 0) {
          menuList = menuList.concat(item.list);
        }
      });
      this.menuListLength = menuList.length;
      console.log(
        "menuGroupLength, menuList",
        this.menuGroup,
        this.menuGroupLength,
        menuList,
        this.menuListLength
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.height0 {
  height: 0 !important;
}
.time-content {
  padding: 10px 0px 10px 0px;
  display: flex;
  flex-flow: column;
  color: #c1bebe;
}
.time-title {
  font-size: 30px;
  padding-bottom: 10px;
}
.time-week {
  padding-left: 10px;
}
.container {
  width: 100%;
  height: 100vh;
  // background: #d5dadd;
  background: RGBA(247, 250, 253, 1);
  color: #ffffff;
}
.header {
  display: flex;
  padding: 0px;
  .logo-content {
    display: flex;
    height: 100%;
    width: fit-content;
    padding: 6px 0 6px 40px;
    box-sizing: border-box;
    img {
      height: 100%;
    }
    .menu {
      margin-top: 16px;
      margin-right: 18px;
      padding: 0 18px 0 0;
      border-right: 1px solid #ffffff;
      height: fit-content;
      // height: 100%;
      // line-height: 48px;
      font-size: 14px;
      color: #ffffff;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.header-top {
  flex: 1;
  text-align: left;
  line-height: 60px;
  padding-left: 20px;
  color: #fff;
  font-size: 20px;
  font-weight: bolder;
}
::v-deep .header-top .menu-item {
  width: auto !important;
  /*flex: 0 !important;*/
  flex: none !important;
}
::v-deep .header-top .menu-item li {
  height: 60px !important;
  line-height: 54px !important;
  // width: 135px!important;
}

::v-deep .header-top .el-submenu__title i {
  color: #999999 !important;
  display: none;
}
::v-deep .icon-shouye {
  display: none;
}
::v-deep .header-top .is-active .el-submenu__title i {
  color: #ffd04b !important;
}
::v-deep .header-top .is-active .el-submenu__title span {
  color: #ffd04b !important;
}
::v-deep .header-top .el-icon-arrow-down {
  display: none;
}

.header-user {
  display: flex;
  align-items: center;
  // flex: 0 0 530px;
  height: 100%;
  color: #ffffff;
  font-size: 16px;
}
.header-user .select {
  background: #2e3842;
}
.user-img {
  padding: 0px 10px;
}
.aside {
  position: relative;
  transform: 0.5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow-x: hidden;
}
.aside .el-menu {
  border-right: 0px;
}
.aside .collapse {
  position: absolute;
  top: 50%;
  right: 0px;
  z-index: 99;
  background: rgba(188, 188, 188, 0.38);
  padding: 10px 0px;
  font-size: 14px;
  width: 16px;
  color: #fff;
  cursor: pointer;
}
.aside .collapse:before,
.aside .collapse:after,
.aside .collapse .collapse_before,
.aside .collapse .collapse_after {
  position: absolute;
  content: "";
}
.aside .collapse:before,
.aside .collapse .collapse_before {
  left: 0px;
  top: 36px;
  border-right: 16px rgba(188, 188, 188, 0.38) solid;
  border-bottom: 16px transparent dashed;
}
.aside .collapse:after,
.aside .collapse .collapse_after {
  left: 0px;
  top: -16px;
  border-top: 16px transparent dashed;
  border-right: 16px rgba(188, 188, 188, 0.38) solid;
}
.aside .collapse .collapse_before {
  border-right: 16px rgba(188, 188, 188, 0.18) solid;
}
.aside .collapse .collapse_after {
  border-right: 16px rgba(188, 188, 188, 0.18) solid;
}
.aside .collapse-time {
  font-size: 22px;
}
.aside .collaspse-time-week {
  flex-flow: column;
  display: flex;
  padding-left: 0px;
}
.footer {
  line-height: 30px;
  background: #f5f7fa;
  color: #030a1e;
  position: relative;
  overflow: hidden;
}
.card {
  display: flex;
  align-items: center;
  background-color: #030a1e;
  padding: 20px;
  transition: 0.3s;
}
.card-hover:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.card-img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.card-content {
  width: 100%;
  height: 100%;
}
.card-bot {
  display: flex;
  align-items: flex-end;
}
.card-content label {
  display: block;
  text-align: left;
}
.card-title {
  text-align: left;
}
.card-num {
  padding: 10px 0px 0px 20px;
  flex: 1;
  font-size: 30px;
  color: #fff;
}
.card-box-title {
  width: 100%;
  text-align: left;
  color: #63a8eb;
  font-size: 16px;
  font-weight: bolder;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}
.tree-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}
.card-box-content {
  padding: 20px 0px;
}
.height-100 {
  height: 100%;
  box-sizing: border-box;
}
.height-100 .el-col {
  height: 100%;
}
.chart {
  width: 100%;
  height: 300px;
}
.main {
  position: relative;
}
.tab-view {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 39px;
  border-bottom: rgb(220, 223, 230);
  // background: #fff;
  background: #e6f7ff;
  display: flex;
  .time {
    padding: 0 0 0 12px;
    line-height: 39px;
    font-size: 14px;
    color: #666666;
  }
}
.router-view {
  position: absolute;
  top: 39px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow: auto;
}
.header-item {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0px 10px;
}
.header-item:hover {
  background: #030a1e50;
  cursor: pointer;
}
.icon-font-22 {
  font-size: 22px;
}

.pop {
  position: fixed;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  z-index: 99 !important;
  display: flex;
  align-items: center;
  .content {
    width: 400px;
    margin: 0px auto;
    margin-top: 300px;
    background: #fff;
    padding: 10px;
    color: #000;
    .content-title {
      text-align: left;
      font-size: 16px;
      padding-bottom: 6px;
    }
    .content-remark {
      padding-left: 80px;
      text-align: left;
    }
    .foot {
      padding-top: 10px;
      display: flex;
      .foot-left {
        flex: 1;
        text-align: left;
        display: flex;
        align-items: center;
        label {
          color: #409eff;
          cursor: pointer;
        }
      }
    }
  }
}

.pop-content {
  margin: 0px auto;
  width: 650px;
  padding-bottom: 10px;
  max-height: 650px;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  background: #fff;
  .title {
    color: #fff;
    height: 40px;
    line-height: 40px;
    background: #3a8ee6;
    text-align: left;
    padding: 0px 10px;
    position: relative;
    display: flex;
    align-items: center;
    .title-lab {
      flex: 1;
    }
    .icon-close {
      position: absolute;
      right: 10px;
      top: 12px;
    }
    .icon-close:hover {
      color: #fd0000;
      cursor: pointer;
    }
  }

  .list {
    width: 100%;
    height: calc(100% - 40px);
    overflow: auto;
    .item {
      width: calc(100% - 20px);
      margin: 10px auto;
      padding: 0px 10px;
      box-sizing: border-box;
      background: #e2dfdf;
      color: #000;
      .item-title {
        height: 30px;
        font-weight: bold;
        display: flex;
        align-items: center;
      }
    }
  }
}
.com-btn {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  width: 300px;
  height: 32px;
  padding-left: 10px;
  background: #fff;
  border-radius: 4px;
  color: #0080ff;
  gap: 10px;
  margin-right: 10px;
  span {
    &:first-child {
      text-align: left;
      flex: 1;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  &-change {
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0080ff90;
    color: #ffffff;
    cursor: pointer;
    &:hover {
      opacity: 0.85;
    }
  }
}
.dropdown-st {
  height: 100%;
  color: #fff;
  font-size: 16px;
}
.menu-left-btn:hover,
.menu-right-btn:hover {
  background: rgb(0 49 109);
  cursor: pointer;
}

.bigScreen {
  height: 56px;
  line-height: 56px;
  padding: 0px 20px;
  text-align: left;
  .el-icon-s-platform {
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    vertical-align: middle;
  }
}
.bigScreen:hover {
  cursor: pointer;
  background-color: #2b2d3a !important;
  color: #409eff !important;
}
</style>

<style type="text/css">
.home {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-box {
  width: 200px;
  height: 200px;
}
.marquee {
  width: 100%;
  height: 30px;
  align-items: center;
  color: #3a3a3a;
  background-color: #fdfbde;
  display: flex;
  box-sizing: border-box;
}

.marquee_box {
  display: block;
  position: relative;
  width: 60%;
  height: 30px;
  overflow: hidden;
}

.marquee_list {
  display: block;
  position: absolute;
  top: 0;
  margin: 0px;
  padding: 0px;
  left: 0;
  list-style: none;
}

.marquee_top {
  transition: all 0.5s;
  margin-top: -30px;
}

.marquee_list li {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  padding-left: 20px;
  text-align: left;
  overflow: hidden;
}

.marquee_list li:hover {
  cursor: pointer;
  text-decoration: underline;
}

.marquee_list li span {
  padding: 0 2px;
  color: #f1543a;
}
</style>

<style lang="scss" scoped>
.internet-content-provider {
  text-decoration: none;
  color: #030a1e;
  &:hover {
    color: #3a8ee6;
  }
}
.weather-box {
  line-height: 39px;
  color: #666;
  img {
    width: 20px;
    position: relative;
    top: 3px;
  }
  label {
    padding-left: 8px;
  }
}
</style>
